// position: 'before' = above target; 'after' = below target.
// 'after' on the LAST row is the only way to land an item at the end.
// Returns null for no-op moves.
export const reorderById = <T>(
  items: readonly T[],
  idOf: (item: T) => string,
  fromId: string,
  toId: string,
  position: 'before' | 'after',
): T[] | null => {
  if (fromId === toId) return null
  const fromIndex = items.findIndex(item => idOf(item) === fromId)
  const toIndex = items.findIndex(item => idOf(item) === toId)
  if (fromIndex < 0 || toIndex < 0 || fromIndex === toIndex) return null
  const desiredIndex = position === 'before' ? toIndex : toIndex + 1
  // Downward moves: post-splice shift left by 1 must be compensated.
  const insertAt = fromIndex < desiredIndex ? desiredIndex - 1 : desiredIndex
  if (insertAt === fromIndex) return null
  const reordered = [...items]
  const [moved] = reordered.splice(fromIndex, 1)
  reordered.splice(insertAt, 0, moved)
  return reordered
}
